import React from 'react'
import dynamic from 'next/dynamic'
import { useTranslation } from 'react-i18next'

const VehicleOptionals = dynamic(() => import('../components/VehicleOptionals'))

const VehicleOptionalsContainer = ({ optionals }) => {
  const { t } = useTranslation()

  return (
    <VehicleOptionals
      title={t('vehicleOptionalsContainer:title')}
      subTitle={t('vehicleOptionalsContainer:subTitle')}
      includedLabel={t('vehicleOptionalsContainer:included')}
      optionals={optionals}
    />
  )
}

export default VehicleOptionalsContainer
